export interface BookPrice {
    lowcount: number;
    highcount: number;
    discounttext: string;
    name: string;
    price: number;
}

export const priceList: Array<BookPrice> = [
    {
        lowcount: 1,
        highcount: 5,
        discounttext: "No discount",
        name: "1 - 5 books",
        price: 30.0
    },
    {
        lowcount: 6,
        highcount: 15,
        name: "6 - 15 books",
        discounttext: "10% discount",
        price: 27.0
    },
    {
        lowcount: 16,
        highcount: 50,
        name: "16 - 50 books",
        discounttext: "15% discount",
        price: 25.5
    },
    {
        lowcount: 51,
        highcount: 99,
        name: "51 - 99 books",
        discounttext: "25% discount",
        price: 22.5
    },
    {
        lowcount: 100,
        highcount: 10000,
        name: "100 or more books",
        discounttext: "30% discount",
        price: 21
    }
];